// Leveranstid på produktsidan: kortare när varan finns i butikens eget lager, längre när den säljs via leverantören
// (fortsatt försäljning påslagen av katalogsynken). Snippeten skriver ut en markering per variant ("b" = butiken, "l" = leverantören) och texterna.
// Temat (Essence) ritar om lagerraden när kunden byter variant, så texten sätts igen vid varje ändring.
(function () {
  'use strict';

  if (window.__aranaLeverans) return;
  window.__aranaLeverans = true;

  var source = document.querySelector('[data-arana-leverans]');
  if (!source) return;
  var status = JSON.parse(source.textContent);
  var texts = window.AranaLeverans || {};

  function productForm() {
    return document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form.product-form[action*="/cart/add"]') ||
      Array.prototype.find.call(document.querySelectorAll('form[action*="/cart/add"]'), function (form) {
        return !/installment/i.test(form.getAttribute('id') || '');
      });
  }

  function selectedVariantId() {
    var form = productForm();
    var id = form ? new FormData(form).get('id') : null;
    return id ? String(id) : (new URLSearchParams(window.location.search).get('variant') || '');
  }

  function update() {
    var box = document.querySelector('[data-variant-info="stock"]');
    if (!box) return;
    var s = status[selectedVariantId()];
    var text = s === 'b' ? texts.butik : (s === 'l' ? texts.leverantor : null);
    if (!text) return;
    var message = box.querySelector('.message');
    if (!message) {
      // Butikens lager är 0 men varan säljs via leverantören: temat har ingen lagerrad, så en skapas.
      message = document.createElement('div');
      box.appendChild(message);
    }
    var klass = 'message message-success text-in-stock-text font-normal';
    if (message.className !== klass) message.className = klass;
    if (message.textContent.trim() !== text) message.textContent = text;
  }

  update();
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      update();
    });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('change', function () {
    window.setTimeout(update, 60);
  });
})();
